/* eslint-disable no-unused-vars */
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import styled, { css } from 'styled-components';
import { ParagraphWithTooltip } from 'components';
import { Palette } from 'config';

export const CountryItem = ({ country, cca2, search$ }) => {
  return (
    <Container>
      <ReactCountryFlag
        countryCode={cca2}
        svg
        style={{
          width: '20px',
          height: '15px',
          marginRight: '8px',
        }}
      />
      <ParagraphWithTooltip
        text={`${country ?? ''} - ${cca2}`}
        isHighlight
        search={search$.value}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 165px;
  cursor: pointer;
`;
